import React, { ReactElement } from 'react';
import { ActionCreatorWithOptionalPayload } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { PageHeading } from '../../../../components/PageHeading';
import { useDeleteVmTemplateMutation } from '../../../../redux/templateManager/VmTemplates/api';
import { useVisibilityFilter } from '../../../../hooks/use-visibility-filter';
import { VmTemplateTable } from './Table';

interface VmTemplateProps {
  isLoading: boolean;
  selectedInventoryItem?: VmTemplate;
  setSelectedInventoryItem: ActionCreatorWithOptionalPayload<
    VmTemplate | undefined,
    string
  >;
  visibilityFilters: TemplateVisibilityValues[];
  vmTemplates: VmTemplateFormattedVisibility[];
}

export function VmTemplates({
  isLoading,
  setSelectedInventoryItem,
  visibilityFilters,
  vmTemplates,
}: VmTemplateProps): ReactElement {
  const { t } = useTranslation();

  const [deleteTemplate, { isLoading: isDeleting }] =
    useDeleteVmTemplateMutation();

  const filteredVmTemplates = useVisibilityFilter({
    templates: vmTemplates,
    visibilityFilters,
  });

  return (
    <section className="half-padding-left">
      <PageHeading pageTitle={t('templateManager.vmTemplates.tabTitle')} />
      <div className="row flex-right">
        <VmTemplateTable
          setSelectedInventoryItem={setSelectedInventoryItem}
          vmTemplates={filteredVmTemplates}
          loading={isDeleting || isLoading}
          deleteVmTemplate={deleteTemplate}
        />
      </div>
    </section>
  );
}
